import { create } from "zustand";

export type ActionToastEntry = {
  id: string;
  key?: string;
  message: string;
  actionLabel: string;
  onAction: () => void;
};

type State = {
  toasts: ActionToastEntry[];
  push: (t: Omit<ActionToastEntry, "id">) => void;
  dismiss: (id: string) => void;
};

export const useActionToast = create<State>((set) => ({
  toasts: [],
  push: (t) =>
    set((s) => ({
      toasts: [
        ...(t.key ? s.toasts.filter((x) => x.key !== t.key) : s.toasts),
        { ...t, id: crypto.randomUUID() },
      ],
    })),
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}));

export const pushActionToast = (t: Omit<ActionToastEntry, "id">) =>
  useActionToast.getState().push(t);
